@if (isLoading()) {
  <div class="fixed inset-0 bg-white dark:bg-gray-900 flex items-center justify-center z-50">
    <app-loading />
  </div>
} @else {
  @if (showLayout$ | async) {
    <app-header />
    <div class="app-component layout-content-wrapper">
      @if (isProjectStepsRoute()) {
        <router-outlet></router-outlet>
      } @else {
        <app-content-wrapper>
          <router-outlet></router-outlet>
        </app-content-wrapper>
      }

      <p-toast position="top-center">
        <ng-template let-message #message>
          <div class="p-toast-message-icon p-toast-message-icon-{{ message.severity }}">
            <i
              class="pi"
              [ngClass]="{
                'pi-info-circle': message.severity === 'info',
                'pi-check': message.severity === 'success',
                'pi-exclamation-triangle': message.severity === 'warn',
                'pi-times-circle': message.severity === 'error',
              }"
            ></i>
          </div>
          <div class="p-toast-message-text">
            <div class="p-toast-summary" data-testid="toast-message-id">{{ message.summary }}</div>
            @if (message.detail) {
              <div class="p-toast-detail" data-testid="toast-message-detail-id">
                {{ message.detail }}
              </div>
            }
          </div>
        </ng-template>
      </p-toast>
    </div>

    <app-footer />
  } @else {
    <div class="fullscreen-content">
      <router-outlet></router-outlet>
      <p-toast position="top-center">
        <ng-template let-message #message>
          <div class="p-toast-message-icon p-toast-message-icon-{{ message.severity }}">
            <i
              class="pi"
              [ngClass]="{
                'pi-info-circle': message.severity === 'info',
                'pi-check': message.severity === 'success',
                'pi-exclamation-triangle': message.severity === 'warn',
                'pi-times-circle': message.severity === 'error',
              }"
            ></i>
          </div>
          <div class="p-toast-message-text">
            <div class="p-toast-summary" data-testid="toast-message-id">{{ message.summary }}</div>
            @if (message.detail) {
              <div class="p-toast-detail" data-testid="toast-message-detail-id">
                {{ message.detail }}
              </div>
            }
          </div>
        </ng-template>
      </p-toast>
    </div>
  }
}

<app-staging-bar />
<app-confirmation-dialog />

@if (isAuthenticated()) {
  <app-chatbot-widget />
}
